import { ContentItem } from 'kentico-cloud-delivery';

export default class Box extends ContentItem {}



// WEBPACK FOOTER //
// ./src/models/Box.js